export enum RouterTypeEnum {
    MPLS = "MPLS",
    SDN_HOSTING = "SDN_HOSTING",
    SDN_ROUTER = "SDN_ROUTER"
}